import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AsociacionClientes from './pages/AsociacionClientes';
import RecetasCruzadas from './pages/RecetasCruzadas';
import RecetasEmitir from './pages/RecetasEmitir';
import Conversaciones from './pages/Conversaciones';
import TrazabilidadAsignaciones from './pages/TrazabilidadAsignaciones';
import PulseLedger from './pages/PulseLedger';
import TrazabilidadRecetas from './pages/TrazabilidadRecetas';
import Llamada from './pages/Llamada';
import BotEncuesta from './pages/BotEncuesta';
import BotEncuestaReview from './pages/BotEncuestaReview';
import Pedidos from './pages/Cadeteria';
import PedidosRecetasMedico from './pages/PedidosRecetasMedico';
import GestionDerivacion from './pages/GestionDerivacion';
import PrivateRecetasRouter from './pages/PrivateRecetasRouter';
import PedidosCallCenter from './pages/PedidosCallCenter';
import BotFarmacia from './pages/BotFarmacia';
import MetodosPago from './pages/MetodosPago';
import GrupoBienestarTyc from './pages/GrupoBienestarTyc';
import CentroRegionalInformacion from './pages/CentroRegionalInformacion';
import BotFarmaciaPromociones from './pages/BotFarmaciaPromociones';
import BotFarmaciaCatalogPublic from './pages/BotFarmaciaCatalogPublic';
import FarmaciaSucursalesAdmin from './pages/FarmaciaSucursalesAdmin';
import FarmaciaPoligonosAdmin from './pages/FarmaciaPoligonosAdmin';
import FarmaciaHorariosBotAdmin from './pages/FarmaciaHorariosBotAdmin';
import MediosPagosPromociones from './pages/MediosPagosPromociones';
import AdminUsuarios from './pages/AdminUsuarios';
import AdminRolesPermisos from './pages/AdminRolesPermisos';
import AdminManualUsuario from './pages/AdminManualUsuario';
import AdminManualConversaciones from './pages/AdminManualConversaciones';
import AdminManualN8n from './pages/AdminManualN8n';
import AdminManualAdministrativo from './pages/AdminManualAdministrativo';
import AdminManualMedico from './pages/AdminManualMedico';
import Configuracion from './pages/Configuracion';
import AdminMedicosVisibilidad from './pages/AdminMedicosVisibilidad';
import AdminAdministrativosVisibilidad from './pages/AdminAdministrativosVisibilidad';
import AdminCallcenterVisibilidad from './pages/AdminCallcenterVisibilidad';
import DeliveryConfig from './pages/DeliveryConfig';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import PrivateLayout from './layouts/PrivateLayout';

function FarmaciaRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/contact-center${search}`} replace />;
}

function LegacyRouteRedirect({ to }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Pública */}
        <Route path="/login" element={<Login />} />
        <Route path="/super-admin/:maintenanceKey" element={<Login />} />
        <Route path="/llamada/:callId" element={<Llamada />} />
        <Route path="/encuesta-bot/r/:token" element={<BotEncuesta mode="respond" />} />
        <Route path="/bot-farmacia/t/:token" element={<BotFarmaciaCatalogPublic />} />
        <Route path="/bot-farmacia/catalogo" element={<Navigate to="/bot-farmacia" replace />} />

        {/* Privadas */}
        <Route
          element={
            <ProtectedRoute>
              <PrivateLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/conversaciones" element={
            <ProtectedRoute permission="ver_conversaciones"><Conversaciones /></ProtectedRoute>
          } />
          <Route path="/delivery" element={
            <ProtectedRoute permission="ver_pedidos"><Pedidos /></ProtectedRoute>
          } />
          <Route path="/cadeteria" element={<LegacyRouteRedirect to="/delivery" />} />
          <Route
            path="/asociacion-clientes"
            element={<ProtectedRoute permission="ver_contactos"><AsociacionClientes /></ProtectedRoute>}
          />
          <Route
            path="/gestion-casos"
            element={
              <ProtectedRoute permission="ver_trazabilidad_asignaciones">
                <TrazabilidadAsignaciones />
              </ProtectedRoute>
            }
          />

          <Route
            path="/farmacia/delivery-config"
            element={
              <ProtectedRoute permission="ver_delivery_config">
                <DeliveryConfig />
              </ProtectedRoute>
            }
          />

          <Route
            path="/metodo-pago"
            element={
              <ProtectedRoute permission="ver_metodo_pago">
                <MetodosPago />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grupo-bienestar-tyc"
            element={
              <ProtectedRoute permission="ver_terminos_condiciones_grupo_bienestar">
                <GrupoBienestarTyc />
              </ProtectedRoute>
            }
          />
          <Route
            path="/centro-regional"
            element={
              <ProtectedRoute permission="ver_informacion_centro_regional">
                <CentroRegionalInformacion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/recetas-cruzadas"
            element={<ProtectedRoute permission="ver_recetas_cruzadas"><RecetasCruzadas /></ProtectedRoute>}
          />
          <Route path="/recetas-emitir" element={<ProtectedRoute permission="ver_recetas_emitir"><RecetasEmitir /></ProtectedRoute>} />
          <Route
            path="/ruta-recetas"
            element={
              <ProtectedRoute permission="ver_trazabilidad_recetas">
                <TrazabilidadRecetas />
              </ProtectedRoute>
            }
          />

          <Route path="/pedidos-recetas-medico"
            element={<ProtectedRoute permission="ver_pedido_recetas_medico"><PedidosRecetasMedico /></ProtectedRoute>} />

          <Route path="/gestion-derivacion"
            element={<ProtectedRoute permission="ver_gestion_derivacion"><GestionDerivacion /></ProtectedRoute>} />

          <Route path="/directorio"
            element={<ProtectedRoute permission="ver_directorio"><PrivateRecetasRouter /></ProtectedRoute>} />

          <Route path="/contact-center"
            element={<ProtectedRoute permission="ver_pedidos_dispensa"><PedidosCallCenter /></ProtectedRoute>} />
          <Route path="/pedidos-call-center" element={<LegacyRouteRedirect to="/contact-center" />} />
          <Route
            path="/bitacora-operativa"
            element={
              <ProtectedRoute permission="ver_pulse_ledger">
                <PulseLedger />
              </ProtectedRoute>
            }
          />
          <Route path="/trazabilidad" element={<LegacyRouteRedirect to="/bitacora-operativa" />} />
          <Route path="/pulse-ledger" element={<LegacyRouteRedirect to="/bitacora-operativa" />} />
          <Route path="/farmacia" element={<FarmaciaRedirect />} />
          <Route path="/farmacia/simulador-bot" element={<Navigate to="/bot-farmacia" replace />} />
          <Route
            path="/bot-farmacia"
            element={
              <ProtectedRoute permission="ver_bot_farmacia">
                <BotFarmacia />
              </ProtectedRoute>
            }
          />
          <Route
            path="/promociones-bancarias"
            element={
              <ProtectedRoute permission="ver_promociones_bancarias">
                <MediosPagosPromociones />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bot-farmacia/promociones"
            element={
              <ProtectedRoute permission="ver_promociones_bot_farmacia">
                <BotFarmaciaPromociones />
              </ProtectedRoute>
            }
          />
          <Route
            path="/farmacia/sucursales"
            element={
              <ProtectedRoute permission="admin_sucursales_farmacia">
                <FarmaciaSucursalesAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/farmacia/poligonos"
            element={
              <ProtectedRoute permission="admin_poligonos_farmacia">
                <FarmaciaPoligonosAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/farmacia/horarios-bot"
            element={
              <ProtectedRoute permission="admin_horarios_botrecetasatencion">
                <FarmaciaHorariosBotAdmin />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/usuarios" element={<ProtectedRoute><AdminUsuarios /></ProtectedRoute>} />
          <Route path="/admin/roles-permisos" element={<ProtectedRoute><AdminRolesPermisos /></ProtectedRoute>} />
          <Route path="/admin/manual-usuario" element={<ProtectedRoute adminOnly><AdminManualUsuario /></ProtectedRoute>} />
          <Route path="/admin/manual-n8n" element={<ProtectedRoute adminOnly><AdminManualN8n /></ProtectedRoute>} />
          <Route
            path="/admin/manual-conversaciones"
            element={
              <ProtectedRoute permission="crear_pedido_alta_rapida">
                <AdminManualConversaciones />
              </ProtectedRoute>}
          />

          <Route
            path="/admin/manual-administrativo"
            element={
              <ProtectedRoute permission="ver_manual_administrativo">
                <AdminManualAdministrativo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/manual-medico"
            element={
              <ProtectedRoute permission="ver_manual_medico">
                <AdminManualMedico />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/configuracion" element={<ProtectedRoute><Configuracion /></ProtectedRoute>} />
          <Route
            path="/admin/medicos-visibilidad"
            element={
              <ProtectedRoute permission="admin_medicos_visibilidad">
                <AdminMedicosVisibilidad />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/administrativos-visibilidad"
            element={
              <ProtectedRoute permission="admin_administrativos_visibilidad">
                <AdminAdministrativosVisibilidad />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/callcenter-visibilidad"
            element={
              <ProtectedRoute permission="admin_callcenter_visibilidad">
                <AdminCallcenterVisibilidad />
              </ProtectedRoute>
            }
          />
          <Route
            path="/encuesta-bot"
            element={
              <ProtectedRoute permission="ver_encuesta_bot">
                <BotEncuesta mode="builder" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/encuesta-bot/review"
            element={
              <ProtectedRoute permission="ver_encuesta_bot_review">
                <BotEncuestaReview />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
